import { motion } from "framer-motion";
import { IMPACT } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Impact = () => (
  <section data-testid="impact-section" id="impact" className="relative py-28 lg:py-40">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="max-w-3xl mb-20">
        <Reveal>
          <Eyebrow testid="impact-eyebrow">The Impact</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
            Numbers that moved <span className="italic text-gold-gradient">the business.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-cream/55 mt-6 text-base sm:text-lg leading-relaxed">
            Six chapters of measurable commercial impact — from D2C turnarounds to
            programmatic returns for international majors.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
        {IMPACT.map((item, i) => (
          <motion.div
            key={item.n}
            data-testid={`impact-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group relative bg-charcoal-900 p-8 lg:p-10 hover:bg-charcoal-800 transition-colors duration-500"
          >
            <span className="text-xs tracking-[0.3em] text-gold/50">{item.n}</span>
            <p className="font-serif text-6xl lg:text-7xl text-gold-gradient leading-none mt-5 mb-4 tracking-tight">
              {item.value}
            </p>
            <p className="text-cream font-medium text-lg mb-3">{item.label}</p>
            <p className="text-cream/45 text-sm leading-relaxed">{item.detail}</p>
            <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold group-hover:w-full transition-all duration-700" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
